<section class="about" [id]="about.id">

    <div class="container about-container">

        <div class="about-image">

            <img [src]="about.imgUrl" alt="About Image">

        </div>

        <div class="about-content">

            <p class="section-subtitle">
                {{ about.subtitle }}
            </p>

            <h2>
                {{ about.title }}
            </h2>

            <div class="about-description">
              @for (paragraph of about.description; track paragraph) {
              <p>
                {{ paragraph }}
              </p>
              }
            </div>

            <a [href]="'#' + environment.FeatureConfig.id" class="primary-btn" >
                {{ about.secondaryButton }}
            </a>

        </div>

    </div>

</section>
